import { Component } from '@angular/core';

@Component({
    selector: 'nio-migration-large-texas-city',
    templateUrl: './migration-large-texas-city.component.html',
    styleUrls: ['./migration-large-texas-city.component.scss'],
    standalone: false
})
export class MigrationLargeTexasCityComponent {}
